export const EASE = [0.16, 1, 0.3, 1];
export const EASE_CUT = [0.76, 0, 0.24, 1];

export const maskUp = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: 0,
    transition: { duration: 1, ease: EASE, delay: i * 0.07 },
  }),
};

export const fadeUp = {
  hidden: { opacity: 0, y: 26 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.85, ease: EASE, delay: i * 0.08 },
  }),
};

export const wipeIn = {
  hidden: { clipPath: "inset(0 0 100% 0)" },
  show: { clipPath: "inset(0 0 0% 0)", transition: { duration: 1.1, ease: EASE } },
};

export const viewport = { once: true, amount: 0.05 };
